<form [formGroup]="form">
    <div class="grid gap-4">
        <sl-select size="small" formControlName="type" label="Type" i18n-label>
            <sl-menu-item value="DayOff" i18n>Day off</sl-menu-item>
            <sl-menu-item value="Vacation" i18n>Vacation</sl-menu-item>
            <sl-menu-item value="AdjustedWorkDay" i18n>Adjusted Work Day</sl-menu-item>
        </sl-select>
        <sl-input *ngIf="type!=='Vacation'" size="small" formControlName="startDate" label="Date" i18n-label
            type="date" hoist></sl-input>
        <sl-fieldset size="small" *ngIf="type==='Vacation'">
            <sl-fieldrow>
                <sl-input formControlName="startDate" label="From" i18n-label type="date" hoist></sl-input>
                <sl-input formControlName="endDate" label="To" i18n-label type="date" hoist></sl-input>
            </sl-fieldrow>
        </sl-fieldset>

        <div *ngIf="type!=='Vacation'" class="grid grid-cols-4">
            <sl-checkbox [checked]="recurringEnabled" (checkedChange)="onCheckedChange($event)" i18n>Recurring</sl-checkbox>
            <sl-select formControlName="recurrenceRule" size="small" class="col-span-3">
                <sl-menu-item value="FREQ=WEEKLY;INTERVAL=1" i18n>Every week</sl-menu-item>
                <sl-menu-item value="FREQ=WEEKLY;INTERVAL=2" i18n>Every second week</sl-menu-item>
                <sl-menu-item value="FREQ=WEEKLY;INTERVAL=4" i18n>Every fourth week</sl-menu-item>
            </sl-select>
        </div>
        <ws-time-period-selector *ngIf="type==='AdjustedWorkDay'" formControlName="workDay" label="Work Hours" i18n-label></ws-time-period-selector>
        <sl-input size="small" formControlName="description" label="Description" placeholder="Optional description"
            i18n-label i18n-placeholder>
        </sl-input>

        <div class="actions mt-8">
            <span *ngIf="isNew"></span>
            <sl-button *ngIf="!isNew" (click)="delete()" type="danger" i18n="@@ExemptionEditorDialog.Delete">Delete absence</sl-button>
            <div>
                <sl-button (click)="cancel()" i18n="@@ExemptionEditorDialog.Cancel">Cancel</sl-button>
                <sl-button *ngIf="isNew" (click)="save()" class="ml-3" type="primary" i18n="@@ExemptionEditorDialog.Add">Add</sl-button>
                <sl-button *ngIf="!isNew" (click)="save()" class="ml-3" type="primary" i18n="@@ExemptionEditorDialog.Save">OK</sl-button>
            </div>
        </div>
    </div>
</form>